module.exports = __webpack_public_path__ + "img/n_4.f9b960db.png";